import { tWithKeyAttr as t } from "../../i18nHelper";
import React from 'react';
import styles from './changeEditingModeButton.module.css';

interface Props {
  translationMode: boolean;
  onToggle: () => void;
}

const ChangeEditingModeButton: React.FC<Props> = ({ translationMode, onToggle }) => {
  const buttonClass = `${styles.btn} ${translationMode ? styles.active : ''}`;

  return (
    <button type="button"className={buttonClass} onClick={onToggle}>
      {translationMode ? t('FINISH_EDITING') : t('CLICK_TO_EDIT_MODE')}
    </button>
  );
};

export default ChangeEditingModeButton;
